// extracted by mini-css-extract-plugin
export var badge = "_hk-2";
export var detailsPanel = "_hk-0";
export var resultRow = "_hk-1";